import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import API_URL from '../../config';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  padding: 3rem 0;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;

const Label = styled.label`
  margin-bottom: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  background-color: transparent;
  padding: 5px;
  border: 1px solid indigo;
  border-radius: 4px;
`;

const TextArea = styled.textarea`
  background-color: transparent;
  padding: 5px;
  border: 1px solid indigo;
  border-radius: 4px;
  resize: vertical;
`;

const Button = styled.button`
  background-color: #461199;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background-color: #361193;
  }
`;

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''; // Handle invalid date
  const options = { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };
  return date.toLocaleString('en-In', options);
};

const BlogCreateForm = ({ blog, setEditMode, getAllBlogs }) => {
  const [editedBlog, setEditedBlog] = useState({
    id: '',
    title: '',
    content: '',
    views: 0,
    createdAt: formatDate(new Date().toISOString())
  });

  useEffect(() => {
    if (blog) {
      setEditedBlog({
        id: blog.id || '',
        title: blog.title || '',
        content: blog.content || '',
        views: blog.views || 0,
        createdAt: blog.createdAt ? formatDate(blog.createdAt) : formatDate(new Date().toISOString())
      });
    }
  }, [blog]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setEditedBlog(prevState => ({
      ...prevState,
      [name]: name === 'views' ? parseInt(value, 10) : value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const method = editedBlog.id ? 'PUT' : 'POST';
      const url = editedBlog.id ? `${API_URL}/update-blog/${editedBlog.id}` : `${API_URL}/create-blog`;

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editedBlog),
      });

      if (!response.ok) {
        throw new Error('Failed to create/update blog');
      }

      getAllBlogs();
      setEditedBlog({
        title: '',
        content: '',
        views: 0,
        createdAt: formatDate(new Date().toISOString())
      });
      setEditMode(false);
    } catch (error) {
      console.error('Error creating/updating blog:', error);
    }
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <InputWrapper>
        <Label>Title:</Label>
        <Input type="text" name="title" value={editedBlog.title} onChange={handleChange} />
      </InputWrapper>
      <InputWrapper>
        <Label>Content:</Label>
        <TextArea name="content" rows={10} value={editedBlog.content} onChange={handleChange} />
      </InputWrapper>
      <Button type="submit">{blog ? 'Update Blog' : 'Create Blog'}</Button>
      {blog && <Button onClick={() => setEditMode(false)}>Cancel</Button>}
    </FormContainer>
  );
};

export default BlogCreateForm;
